(function ($, window) {
    let prodigy_product_personalization = {
        prodigy_personalization_input_element: '.prodigy-personalization__input-js',

        init: function () {
            if (this.is_personalization()) {
                this.input_personalization_field();
            }
        },

        input_personalization_field: function () {
            $(this.prodigy_personalization_input_element).on('input', function () {
                if (prodigyProductBulk.is_active_logo_bulk) {
                    let bulk_data = $('#variant-data-js').data('bulk-variants');
                    prodigyProductBulk.update_bulk_price(bulk_data);
                    prodigyProduct.update_bulk_info(bulk_data.result);
                } else {
                    if (prodigyProduct.is_variants()) {
                        let variant_data = $('#variant-data-js').data('variant');
                        prodigyProduct.set_variants_data(variant_data);
                        prodigyProduct.set_product_data_for_cart(variant_data);
                        prodigyProduct.set_shipping_data(variant_data);
                        prodigyProduct.disable_add_to_cart_button_loader();
                        if (!prodigyProduct.is_bulk_opened() && !prodigyProduct.is_variant_was_chosen && prodigyProduct.is_tiered_price) {
                            prodigyProduct.set_tiered_prices(variant_data);
                        }
                    } else {
                        prodigyProduct.show_master_variant_info();
                    }
                }
            });

        },

        is_personalization_filled: function () {
            let is_personalization_filled = false;
            $(this.prodigy_personalization_input_element).each(function () {
                if ($(this).val().length > 0) {
                    is_personalization_filled = true;
                }
            });

            return is_personalization_filled;
        },

        is_personalization: function () {
            return $('#personalization-price-modifier-js').length > 0;
        },

        is_valid_personalization_price: function (value) {
            return value !== undefined && value !== null && value !== '' && !isNaN(value);
        },

        calculate_personalization_price: function (price) {
            let personalization_modifier_type = $('#personalization-price-modifier-js').val();
            let personalization_modifier_value = $('#personalization-price-value-js').val();
            let personalization_price = 0;

            if (
                personalization_modifier_type &&
                this.is_valid_personalization_price(personalization_modifier_value)
            ) {
                if (personalization_modifier_type === 'flat') {
                    personalization_price = parseFloat(personalization_modifier_value);
                } else {
                    personalization_price = prodigy_price_format((parseFloat(price) * personalization_modifier_value) / 100);
                }
            }

            return personalization_price;
        },


        is_user_personalization_validate: function () {
            let result = true;
            $(this.prodigy_personalization_input_element).each(function () {
                if ($(this).val().trim() === '' && $(this).data('required') !== '') {
                    $(this).closest('.prodigy-personalization__label-js').addClass('prodigy-personalization__field-has-error');
                    result = false;
                }
            });

            return result;
        },

        delete_personalization_errors: function () {
            $('.prodigy-personalization__label-js').each(function () {
                $(this).removeClass('prodigy-personalization__field-has-error');
            });
        },

        get_personalization_data: function () {
            let myObj = [];

            $(this.prodigy_personalization_input_element).each(function () {
                let obj = {
                    personalization_id: $(this).data('id'),
                    personalization_field_id: $(this).data('field-id'),
                    value: $(this).val(),
                };
                myObj.push(obj);
            });

            return myObj;
        },

    };
    window.prodigyProductPersonalization = prodigy_product_personalization;
})(jQuery, window);

jQuery(document).ready(
    function ($) {
        window.prodigyProductPersonalization.init();
    }
);